import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../core/http/api.service';
import { DropdownItem } from '../models/common.model';
import { API_URL } from './api.constant';
import { featureFlag } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DropdownService {
  constructor(
    private http: HttpClient,
    private httpClient: ApiService,
  ) {}

  getDropdown<Value = number>(
    params,
  ): Observable<{ [dropdownName: string]: DropdownItem<Value>[] }> {
    return this.httpClient.get<{
      [dropdownName: string]: DropdownItem<Value>[];
    }>(API_URL.dropdown, params);
  }

  getDropdownWithHeader(header, params) {
    return this.http.get(environment.baseUrl + API_URL.dropdown, {
      params,
      headers: header,
    });
  }

  memoTypeItem() {
    const memo_types = [
      {
        label: 'External',
        value: 'external',
        context: {
          display_name: 'แบบขออนุมัติภายนอก',
          display_name_en: 'External',
        },
      },
      {
        label: 'Internal',
        value: 'internal',
        context: {
          display_name: 'แบบขออนุมัติภายใน',
          display_name_en: 'Internal',
        },
      },
      // {
      //   label: 'Purchase Request',
      //   value: 'purchase_request',
      //   context: {
      //     display_name: 'แบบขออนุมัติการซื้อ',
      //     display_name_en: 'Purchase Request',
      //   },
      // },
      {
        label: 'Authorization Form',
        value: 'authorization_form',
        context: {
          display_name: 'แบบฟอร์ม Authorization',
          display_name_en: 'Authorization Form',
        },
      },
      {
        label: 'Payment Voucher (Budget)',
        value: 'payment_voucher',
        context: {
          display_name: 'ใบสำคัญจ่าย (งบประมาณ)',
          display_name_en: 'Payment Voucher (Budget)',
        },
      },
      {
        label: 'Adjustment Form',
        value: 'adjustment_form',
        context: {
          display_name: 'แบบฟอร์มขอปรับงบประมาณ',
          display_name_en: 'Adjustment Form',
        },
      },
      {
        label: 'Contract Form',
        value: 'contract_form',
        context: {
          display_name: 'แบบฟอร์มสัญญา',
          display_name_en: 'Contract Form',
        },
      },
      {
        label: 'Payment Form',
        value: 'payment_form',
        context: {
          display_name: 'แบบฟอร์มการชำระเงิน',
          display_name_en: 'Payment Form',
        },
      },
      {
        label: 'Request Advance Form',
        value: 'request_advance_form',
        context: {
          display_name: 'แบบฟอร์มขอเบิกเงินล่วงหน้า',
          display_name_en: 'Request Advance Form',
        },
      },
      {
        label: 'Clear Advance Form',
        value: 'clear_advance_form',
        context: {
          display_name: 'แบบฟอร์มขอเคลียร์เงินล่วงหน้า',
          display_name_en: 'Clear Advance Form',
        },
      },
      {
        label: 'Upload',
        value: 'upload',
        context: {
          display_name: 'เอกสารอัปโหลด',
          display_name_en: 'Upload',
        },
      },
    ];
    if (featureFlag.memo_enable) {
      return memo_types;
    } else {
      return [];
    }
  }
}

export interface DropdownResponse {
  [type: string]: {
    label: any;
    value: any;
    context?: any;
  }[];
}
